var render, staticRenderFns
import script from "./CommonAutoLink.vue?vue&type=script&lang=js&"
export * from "./CommonAutoLink.vue?vue&type=script&lang=js&"
import style0 from "./CommonAutoLink.vue?vue&type=style&index=0&id=468a4789&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468a4789",
  null
  
)

export default component.exports